import {
    colorBaseGreyCool50,
    colorBaseGreyCool200,
    colorBaseGreyCool500,
    colorBaseWhite,
    IconCloseCircleFill,
    layoutMarginSmall,
    paragraphSmallFontSize,
    paragraphSmallFontWeight,
    paragraphTinyFontSize,
} from '@issuu/silkscreen';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import DocumentContext from '../DocumentPage/DocumentContext';
import { TruncatedSpan } from '../shared/styles';

const PREVIEW_CONTENT_WIDTH = '15em';
const PREVIEW_CONTENT_HEIGHT = '7.9em';

const Description = styled.div`
    max-width: ${PREVIEW_CONTENT_WIDTH};
    font-size: ${paragraphTinyFontSize};
`;

const Title = styled.div`
    max-width: ${PREVIEW_CONTENT_WIDTH};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${paragraphSmallFontWeight};
    font-size: ${paragraphSmallFontSize};
    margin-bottom: 0.5em;
    line-height: 1.5em;
`;

const PreviewRoot = styled.div`
    background-color: ${colorBaseGreyCool50};
    padding: ${layoutMarginSmall};
    min-width: 0;
    flex-shrink: 1;
`;

const PreviewSmallTitle = styled.div`
    text-transform: uppercase;
    color: ${colorBaseGreyCool200};
    margin-bottom: 1em;
    font-size: ${paragraphTinyFontSize};
`;

const ImageLoadError = styled.div`
    max-width: ${PREVIEW_CONTENT_WIDTH};
    max-height: ${PREVIEW_CONTENT_HEIGHT};
    display: flex;
    justify-content: center;
    align-items: center;
`;

const PreviewBlock = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${colorBaseWhite};
    border: 1px solid ${colorBaseGreyCool500};
    padding: ${layoutMarginSmall};
    min-height: 13em;

    img {
        max-width: ${PREVIEW_CONTENT_WIDTH};
        max-height: ${PREVIEW_CONTENT_HEIGHT};
    }
`;

type Props = {
    pageNumber: number;
};

export const ShareBoxPreview: React.FC<Props> = ({ pageNumber }: Props) => {
    const {
        document: { revisionId, publicationId, description, title },
        hosts: { multimedia },
        publisher: { displayName },
    } = useContext(DocumentContext);

    const [isImageError, setIsImageError] = useState<boolean>(false);

    useEffect(() => setIsImageError(false), [pageNumber]);
    const cover = `//${multimedia}/document/${revisionId}-${publicationId}/${pageNumber}/spread.jpg`;

    return (
        <PreviewRoot>
            <PreviewSmallTitle>preview</PreviewSmallTitle>
            <PreviewBlock>
                {isImageError ? (
                    <ImageLoadError>
                        <IconCloseCircleFill />
                    </ImageLoadError>
                ) : (
                    <img onError={() => setIsImageError(true)} src={cover} />
                )}
                <Title>
                    {displayName} - {title}
                </Title>
                <Description>
                    <TruncatedSpan lines={2}>{description}</TruncatedSpan>
                </Description>
            </PreviewBlock>
        </PreviewRoot>
    );
};
